/* Melinava: Wisch-Hinweis für seitlich scrollbare Kartenreihen (Elemente mit data-mv-wischen, Text aus mv.allgemein.wischen).
   Nur wenn die Reihe wirklich überläuft (am Handy): Punkte je Karte plus "Wischen für mehr", der Text blendet nach dem ersten Wischen aus. */
(function () {
  function setup(row) {
    if (row.dataset.mvWischenOk) return;
    row.dataset.mvWischenOk = '1';
    var cards = Array.prototype.filter.call(row.children, function (c) { return c.offsetParent !== null || c.getClientRects().length; });
    var hint = document.createElement('div');
    hint.className = 'mv-wisch';
    hint.setAttribute('aria-hidden', 'true');
    var dots = document.createElement('div');
    dots.className = 'mv-wisch__dots';
    cards.forEach(function () { dots.appendChild(document.createElement('span')); });
    var text = document.createElement('span');
    text.className = 'mv-wisch__text';
    text.innerHTML = (row.getAttribute('data-mv-wischen') || 'Wischen für mehr') + ' <svg viewBox="0 0 16 10" width="16" height="10"><path d="M1 5h13M10 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    hint.appendChild(dots);
    hint.appendChild(text);
    row.parentNode.insertBefore(hint, row.nextSibling);
    function update() {
      var over = row.scrollWidth > row.clientWidth + 4;
      hint.hidden = !over;
      if (!over) return;
      var max = row.scrollWidth - row.clientWidth;
      var i = max > 0 ? Math.round(row.scrollLeft / max * (cards.length - 1)) : 0;
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
      if (row.scrollLeft > 20) hint.classList.add('is-gewischt');
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function init() { document.querySelectorAll('[data-mv-wischen]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
